import React, {useContext} from 'react'
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import {Collapse} from "@material-ui/core";


function ContractorNotDivided(
    {
        id,
        formikProps,
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const tenderCompletedWithContract = getObjectValue("form.tenderCompletionData.notDivided.tenderCompletionType", formikProps.values, null) === "zawarcieUmowy";
    const {getDict} = useContext(FormTranslationContext)

    return (<>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("awardedToGroup")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            id={gId("contractorCompanySize")}
            formikProps={formikProps}
            items={getDict("ENUM.004")}
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("nationalRegistrationNumber")}
            required={tenderCompletedWithContract}
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("contractorName")}
            required={tenderCompletedWithContract}
        />

        <Collapse in={gVal("awardedToGroup") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("otherContractorNames")}
                required={tenderCompletedWithContract}
            />
        </Collapse>

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("street")}
            required={tenderCompletedWithContract}
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("city")}
            required={tenderCompletedWithContract}
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("postCode")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            id={gId("state")}
            formikProps={formikProps}
            items={getDict("SL.MT.007")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            id={gId("country")}
            formikProps={formikProps}
            items={getDict("SL.MT.005")}
            required={tenderCompletedWithContract}
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("subcontracted")}
            required={tenderCompletedWithContract}
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("infoAboutPartsOfTheContractToBeSubcontracted")}
        />

    </>)
}

ContractorNotDivided.propTypes = {};

export default ContractorNotDivided;
